import React from 'react';
import ErrorFallback from './ErrorFallback';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.handleReset = this.handleReset.bind(this);
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('Uncaught error:', error, info);
    }

    handleReset() {
        this.setState({ hasError: false });
    }

    render() {
        if (this.state.hasError) {
            return <ErrorFallback onReset={this.handleReset} />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
